export default "__VITE_ASSET__d2e28702__"